var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tuple-argument-wrapper"},[_c('ArgumentHandler',{staticClass:"tuple-argument-item",attrs:{"argument":_vm.arg,"disabled":_vm.disabled,"defaultValue":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }